var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c_chip__container"},[_c('div',{staticClass:"c_chip",style:(`--chip-background:${_vm.chipStyle};`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }